import { type FC } from 'react'
import classNames from 'classnames'
import { RUN_LIVE_STATUSES, runStatusLabel } from './runStatus'
import styles from './CustomWorkflows.module.scss'

interface StatusStyle {
  classes: string
  icon?: string
}

const DEFAULT_STYLE: StatusStyle = { classes: 'zocks-bg-color-gray-200 zocks-text-gray-700 zocks-border-color-gray-300' }

const STATUS_STYLES: Record<string, StatusStyle> = {
  succeeded: { classes: 'zocks-bg-color-success-background zocks-text-success zocks-border-color-success-light', icon: 'bi-check-circle' },
  failed: { classes: 'zocks-bg-color-danger-background zocks-text-danger zocks-border-color-danger-light', icon: 'bi-x-circle' },
  stopped: { ...DEFAULT_STYLE, icon: 'bi-slash-circle' },
  'partial-succeeded': { classes: 'zocks-bg-color-warning zocks-text-warning-dark zocks-tag-border-amber', icon: 'bi-exclamation-circle' },
  running: { classes: 'zocks-bg-color-primary-light zocks-text-primary zocks-tag-border-violet' },
  scheduled: { classes: 'zocks-bg-color-primary-light zocks-text-primary zocks-tag-border-violet' },
  paused: { classes: 'zocks-bg-color-warning zocks-text-warning-dark zocks-tag-border-amber', icon: 'bi-hourglass-split' },
}

export const WorkflowRunStatusBadge: FC<{ status: string }> = ({ status }) => {
  const style = STATUS_STYLES[status] ?? DEFAULT_STYLE
  const live = RUN_LIVE_STATUSES.includes(status)
  return (
    <span className={classNames('d-inline-flex align-items-center gap-1 px-2 py-1 rounded-2 paragraph-extra-small medium border flex-shrink-0', style.classes)}>
      {live ? <span className={classNames(styles.pulseDot, styles.statusDot)} /> : null}
      {!live && style.icon ? <i className={classNames('bi', style.icon)} aria-hidden='true' /> : null}
      {runStatusLabel(status)}
    </span>
  )
}
